import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import type { FeatureFlagRecord } from "../FeatureFlagRecord";

export function getQueryKey() {
  return ["featureFlagRecords"];
}

export function useFeatureFlags() {
  const { featureFlagService } = useDomainServices();

  return useQuery<FeatureFlagRecord[], Error>({
    queryKey: getQueryKey(),
    queryFn({ signal }) {
      return featureFlagService.getAll({ abortSignal: signal });
    },
  });
}
